import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE } from './apiConfig';

// Բաղադրիչների ներմուծում
import AdminAnalytics from './components/AdminAnalytics';
import AdminOrders from './components/AdminOrders';
import AdminPortfolio from './components/AdminPortfolio';
import AdminServices from './components/AdminServices';
import AdminStandardSection from './components/AdminStandardSection';
import AdminFAQSection from './components/AdminFAQSection';
import AdminStaticContent from './components/AdminStaticContent';
import AdminMessages from './components/AdminMessages';
import AdminReviews from './components/AdminReviews';
import AdminChatBotTrainer from './components/AdminChatBotTrainer';
import AdminNotifications from './components/AdminNotifications';
import AdminWorkers from './components/AdminWorkers';
import AdminUsers from './components/AdminUsers'; 
import AdminWallet from './components/AdminWallet'; 
import AdminAssets from './components/AdminAssets'; 
import AdminCars from './components/AdminCars'; 
import AdminBlog from './components/AdminBlog'; 
const Admin = () => {
    const { t } = useTranslation();
    const [isLogged, setIsLogged] = useState(localStorage.getItem('liber_admin') === 'true');
    const [login, setLogin] = useState({ username: '', password: '' });
    const [tab, setTab] = useState('analytics');
    const [list, setList] = useState([]);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleLogout = useCallback(() => {
        localStorage.removeItem('liber_admin');
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        setIsLogged(false);
        window.location.reload();
    }, []);

    const loadData = useCallback(async () => {
        if (!isLogged) return;
        try {
            let endpoint = tab;
            if (tab === 'reviews') endpoint = 'reviews';
            if (tab === 'messages') endpoint = 'messages';
            
            const customFetchTabs = [
                'analytics', 'about', 'settings', 'orders', 
                'bot', 'notifications', 'workers', 'users', 'wallet','assets','cars','blog'
            ];
            
            if (customFetchTabs.includes(tab)) return;

            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE}/api/${endpoint}`, {
                headers: { 
                    'ngrok-skip-browser-warning': 'true',
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (res.status === 401) {
                handleLogout();
                return;
            }

            const data = await res.json();
            setList(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error("Error loading data:", e);
        }
    }, [tab, isLogged, handleLogout]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${API_BASE}/api/auth/admin-login`, { 
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(login)
            });
            const data = await res.json();
            if (data.success && data.token) {
                localStorage.setItem('liber_admin', 'true');
                localStorage.setItem('token', data.token); 
                localStorage.setItem('role', 'admin');
                setIsLogged(true);
            } else {
                alert(data.error || "Սխալ մուտքանուն կամ գաղտնաբառ");
            }
        } catch (err) {
            alert("Սերվերի հետ կապի սխալ");
        }
    };

    const menuItems = [
        { id: 'analytics', icon: '📊', n: t('admin_analytics') },
        { id: 'workers', icon: '👷', n: t('admin_workers') }, 
        { id: 'users', icon: '👥', n: t('admin_users') },
        { id: 'wallet', icon: '💳', n: t('admin_wallet') },
        { id: 'orders', icon: '📦', n: t('admin_orders') },
        { id: 'assets', icon: '🧮', n: t('admin_assets') },
        { id: 'cars', icon: '🚗', n: t('admin_cars') },
        { id: 'blog', icon: '✍️', n: 'Բլոգ' },
        { id: 'messages', icon: '✉️', n: t('admin_messages') },
        { id: 'bot', icon: '🤖', n: t('admin_bot') },
        { id: 'notifications', icon: '📣', n: t('admin_notifications') },
        { id: 'portfolio', icon: '🏗', n: t('admin_portfolio') },
        { id: 'subservices', icon: '🛠', n: t('admin_services') },
        { id: 'slides', icon: '🖼️', n: t('admin_slides') },
        { id: 'categories', icon: '📁', n: t('admin_categories') },
        { id: 'partners', icon: '🤝', n: t('admin_partners') },
        { id: 'reviews', icon: '⭐', n: t('admin_reviews') },
        { id: 'faq', icon: '❓', n: t('admin_faq') },
        { id: 'about', icon: 'ℹ️', n: t('admin_about') },
        { id: 'settings', icon: '📞', n: t('admin_contacts') }
    ];

    if (!isLogged) return (
        <div style={loginScreenStyle}>
            <form onSubmit={handleLogin} style={loginBoxStyle}>
                <div style={logoCircle}>L</div>
                <h2 style={{color: '#1B2559', marginBottom: '10px', fontWeight: '800'}}>LIBER ADMIN</h2>
                <p style={{color: '#A3AED0', marginBottom: '30px', fontSize: '14px'}}>{t('admin_welcome')}</p>
                <input style={adminInputStyle} type="text" placeholder={t('username')} onChange={e => setLogin({...login, username: e.target.value})} required />
                <input style={adminInputStyle} type="password" placeholder={t('password')} onChange={e => setLogin({...login, password: e.target.value})} required />
                <button style={saveButtonStyle} type="submit">{t('login_btn')}</button>
            </form>
        </div>
    );

    return (
        <>
            <style>{scopedAdminCSS}</style>
            <div className={`admin-page ${isMenuOpen ? 'menu-open' : ''}`}>
                
                {/* Mobile Header / Burger Button */}
                <div className="mobile-header">
                    <button className="burger-btn" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        {isMenuOpen ? '✕' : '☰'}
                    </button>
                    <div className="mobile-logo">LIBER ADMIN</div>
                </div>

                <aside className={`admin-sidebar ${isMenuOpen ? 'open' : ''}`}>
                    <div className="sidebar-logo">
                        <span style={{color: '#f7f6f1'}}>LIBER</span> GROUP
                    </div>
                    <nav className="sidebar-nav">
                        {menuItems.map(m => (
                            <button 
                                key={m.id} 
                                className={`nav-item ${tab === m.id ? 'active' : ''}`} 
                                onClick={() => { setTab(m.id); setIsMenuOpen(false); }}
                            >
                                <span className="nav-icon">{m.icon}</span>
                                <span className="nav-text">{m.n}</span>
                            </button>
                        ))}
                    </nav>
                    <button onClick={handleLogout} className="logout-btn">🚪 {t('logout')}</button>
                </aside>

                {/* Overlay for mobile */}
                {isMenuOpen && <div className="sidebar-overlay" onClick={() => setIsMenuOpen(false)}></div>}

                <main className="admin-main">
                    <div className="content-container">
                        <header className="main-header">
                            <h1 className="page-title">{menuItems.find(i => i.id === tab)?.n}</h1>
                        </header>
                        
                        <div className="tab-render-area">
                            {tab === 'analytics' && <AdminAnalytics />}
                            {tab === 'workers' && <AdminWorkers />}
                            {tab === 'users' && <AdminUsers />}
                            {tab === 'wallet' && <AdminWallet />}
                            {tab === 'orders' && <AdminOrders />}
                            {tab === 'assets' && <AdminAssets />}
                            {tab === 'cars' && <AdminCars />}
                            {tab === 'blog' && <AdminBlog />} 
                            {tab === 'bot' && <AdminChatBotTrainer />}
                            {tab === 'notifications' && <AdminNotifications />}
                            {tab === 'reviews' && <AdminReviews />}
                            {tab === 'messages' && <AdminMessages list={list} refresh={loadData} />}
                            {tab === 'portfolio' && <AdminPortfolio list={list} refresh={loadData} />}
                            {tab === 'subservices' && <AdminServices list={list} refresh={loadData} />}
                            {tab === 'faq' && <AdminFAQSection list={list} refresh={loadData} />}
                            {['slides', 'categories', 'partners'].includes(tab) && <AdminStandardSection tab={tab} list={list} refresh={loadData} />}
                            {['about', 'settings'].includes(tab) && <AdminStaticContent tab={tab} />}
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

// --- STYLES ---

const scopedAdminCSS = `
    .admin-page {
        --gold: #bd871b;
        --dark-bg: #111111;
        --main-bg: #f8f9fa;
        --text-white: #ffffff;
        
        display: flex; height: 100vh; width: 100%; background: var(--main-bg);
        position: fixed; top: 0; left: 0; z-index: 9999; font-family: 'Plus Jakarta Sans', sans-serif;
    }

    .mobile-header { display: none !important; }

    .admin-sidebar { 
        width: 290px; 
        background: var(--dark-bg) !important; 
        display: flex; flex-direction: column; height: 100vh; 
        border-right: 1px solid rgba(255, 215, 0, 0.1);
        transition: transform 0.3s ease;
        transform: translateX(0) !important;
    }

    /* DESKTOP LOGO: Luxury Stroke */
    .sidebar-logo { 
        padding: 50px 20px; 
        font-size: 26px; 
        font-weight: 900; 
        color: #ffffff !important; 
        text-align: center;
        letter-spacing: 4px;
        text-transform: uppercase;
        -webkit-text-stroke: 1px var(--gold); 
    }
    
    .sidebar-nav { flex: 1; overflow-y: auto; padding: 10px 20px; display: flex; flex-direction: column; gap: 8px; }

    .nav-item { 
        padding: 14px 16px; border: none; background: transparent; 
        color: var(--text-white) !important; 
        text-align: left; border-radius: 12px; cursor: pointer; 
        font-weight: 600; transition: 0.3s; 
        display: flex; align-items: center; gap: 12px; font-size: 15px; 
    }

    .nav-item.active { 
        background: rgba(189, 135, 27, 0.15) !important; 
        color: var(--gold) !important; 
        box-shadow: inset 0 0 5px rgba(189, 135, 27, 0.2);
    }

    .nav-item:hover { background: rgba(255, 255, 255, 0.05); color: var(--gold) !important; }

    .logout-btn { 
        margin: 20px; padding: 15px; 
        background: rgba(238, 93, 80, 0.05); 
        color: #EE5D50; border: 1px solid rgba(238, 93, 80, 0.2); 
        border-radius: 12px; font-weight: 800; cursor: pointer; 
    }

    .admin-main { flex: 1; overflow-y: auto; padding: 40px; position: relative; }

    @media (max-width: 1024px) {
        .mobile-header {
            display: flex !important; align-items: center; justify-content: space-between;
            position: fixed; top: 0; left: 0; right: 0; height: 75px;
            background: var(--dark-bg); padding: 0 20px; z-index: 10000;
            border-bottom: 1px solid var(--gold);
        }

        .burger-btn {
            background: transparent;
            border: 2px solid var(--gold);
            color: var(--gold);
            width: 46px; height: 46px;
            border-radius: 10px;
            display: flex; align-items: center; justify-content: center;
            font-size: 24px; cursor: pointer;
            transition: 0.3s;
        }
@media (max-width: 1024px) {
        .mobile-header {
            display: flex !important; 
            align-items: center; 
            justify-content: space-between;
            position: fixed; 
            top: 0; 
            left: 0; 
            right: 0; 
            height: 70px; /* Հաստատուն բարձրություն */
            background: var(--dark-bg); 
            padding: 0 20px; 
            z-index: 11000; /* Ավելի բարձր քան sidebar-ը */
            border-bottom: 1px solid rgba(189, 135, 27, 0.3);
        }

        .admin-sidebar { 
            position: fixed; 
            left: 0; 
            top: 0; 
            transform: translateX(-100%) !important; 
            z-index: 10500; 
            padding-top: 80px; /* Սա է լուծումը. իջեցնում է մենյուն հեդերի տակից */
            width: 280px;
            box-shadow: 10px 0 30px rgba(0,0,0,0.5);
        }

        .admin-sidebar.open { 
            transform: translateX(0) !important; 
        }

        .admin-main { 
            padding: 100px 20px 20px 20px; /* Հիմնական կոնտենտն էլ իջեցնում ենք */
        }

        .burger-btn {
            background: transparent;
            border: 1px solid var(--gold);
            color: var(--gold);
            width: 40px; 
            height: 40px;
            border-radius: 8px;
            display: flex; 
            align-items: center; 
            justify-content: center;
            font-size: 20px; 
            cursor: pointer;
            z-index: 11001;
        }

        .sidebar-overlay { 
            position: fixed; 
            top: 0; 
            left: 0; 
            right: 0; 
            bottom: 0; 
            background: rgba(0,0,0,0.7); 
            z-index: 10000; 
            backdrop-filter: blur(4px); 
        }
    }
        /* --- UNIVERSAL MOBILE OPTIMIZATION --- */

@media (max-width: 768px) {
    /* 1. Էջի ընդհանուր կոնտեյները */
    .admin-main {
        padding: 90px 15px 20px 15px !important;
    }

    .page-title {
        font-size: 22px !important;
        margin-bottom: 20px !important;
        text-align: center;
        color: var(--dark-bg);
    }

    /* 2. Աղյուսակների (Tables) ձևափոխում քարտերի */
    /* Եթե քո բաղադրիչներում table կա, սա այն կդարձնի scrollable կամ կվերացնի սեղմվածությունը */
    .tab-render-area {
        overflow-x: hidden;
    }

    table {
        display: block;
        overflow-x: auto;
        white-space: nowrap;
        background: #fff;
        border-radius: 15px;
        padding: 10px;
        box-shadow: 0 5px 15px rgba(0,0,0,0.05);
    }

    /* 3. Քարտերի (Cards) սիրունացում */
    .analytics-card, .stat-card, .admin-card {
        width: 100% !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        margin-bottom: 15px !important;
        padding: 20px !important;
        border-radius: 20px !important;
        border: 1px solid rgba(189, 135, 27, 0.1) !important;
    }

    /* 4. Ֆորմաների (Inputs) ու Կոճակների հարմարեցում */
    input, select, textarea {
        font-size: 16px !important; /* Մոբայլում zoom չանելու համար */
        padding: 12px !important;
    }

    button {
        min-height: 48px; /* Մատով կպնելու համար հարմար */
    }

    /* 5. Գործողությունների կոճակները (Edit/Delete) սարքել ավելի մեծ */
    .action-btns {
        display: flex;
        gap: 10px;
        justify-content: center;
    }

    /* 6. Dashboard-ի վիճակագրության grid-ը սարքել 1 սյունակ */
    .stats-grid {
        display: grid;
        grid-template-columns: 1fr !important;
        gap: 15px;
    }
}

/* --- LUXURY SCROLLBAR (Ոսկեգույն սկրոլ) --- */
.admin-sidebar::-webkit-scrollbar {
    width: 4px;
}
.admin-sidebar::-webkit-scrollbar-thumb {
    background: var(--gold);
    border-radius: 10px;
}
    
        .mobile-logo { color: var(--gold); font-weight: 800; text-transform: uppercase; }

        .admin-sidebar { position: fixed; left: 0; top: 0; transform: translateX(-100%) !important; z-index: 10001; }
        .admin-sidebar.open { transform: translateX(0) !important; }
        .sidebar-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.85); z-index: 10000; backdrop-filter: blur(6px); }
    }
`;

/* --- LOGIN SCREEN (ԼՐԻՎ ՈՍԿԵԳՈՒՅՆ ՈՒ ՍՊԻՏԱԿ) --- */
const loginScreenStyle = { 
    display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', 
    background: '#0a0a0a', /* Սարքեցի մուգ, որ ոսկին վառվի */
    position: 'fixed', width: '100%', top: 0, left: 0, zIndex: 10000 
};

const loginBoxStyle = { 
    background: '#111', padding: '50px', borderRadius: '30px', 
    boxShadow: '0 25px 60px rgba(0,0,0,0.5)', textAlign: 'center', 
    width: '90%', maxWidth: '400px', border: '1px solid rgba(189, 135, 27, 0.2)' 
};

const logoCircle = { 
    width: '80px', height: '80px', 
    background: 'linear-gradient(135deg, #bd871b, #e6b965)', /* Ոսկեգույն գրադիենտ */
    borderRadius: '22px', margin: '0 auto 25px', color: '#000', 
    display: 'flex', alignItems: 'center', justifyContent: 'center', 
    fontSize: '35px', fontWeight: '900', boxShadow: '0 10px 20px rgba(189, 135, 27, 0.3)' 
};

const adminInputStyle = { 
    width: '100%', padding: '16px', marginBottom: '15px', borderRadius: '12px', 
    border: '1px solid #333', outline: 'none', background: '#050505', color: '#fff', boxSizing: 'border-box' 
};

const saveButtonStyle = { 
    width: '100%', padding: '18px', borderRadius: '12px', border: 'none', 
    background: 'linear-gradient(135deg, #bd871b, #e6b965)', /* Ոսկեգույն կոճակ */
    color: '#000', fontWeight: '900', cursor: 'pointer', 
    textTransform: 'uppercase', letterSpacing: '1px' 
};

export default Admin;